import React from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

const Loading: React.FC = () => {
  return (
    <Box
      css={{ height: '100%', flexGrow: 1 }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <div>
        <CircularProgress size={64} />
      </div>
    </Box>
  );
};

export default Loading;
